module.exports = __webpack_public_path__ + "media/images/flags/1x1/wsm-73908f33b23138de83de2d847cf818a8.svg";